/**
 * Вкладка Chats админки.
 */

function DevChats({ sessions, error, loading }) {
    const items = sessions || [];

    return (
        <div className="dev-page">
            <h2 className="dev-page__title">Chats</h2>
            <p className="dev-page__desc">Сессии онлайн-чата.</p>
            {error ? <div className="dev-admin__status dev-admin__status_error">{error}</div> : null}
            {loading && !sessions ? <p className="dev-admin__muted">Loading...</p> : null}
            {!loading && items.length === 0 ? (
                <p className="dev-admin__muted">No active chat sessions</p>
            ) : (
                <ul className="dev-admin__list">
                    {items.map((session) => (
                        <li key={session.id} className="dev-admin__item">
                            <code>{session.id}</code>
                            <span>{session.lastActivity}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default DevChats;
// components/DevAdmin/DevChats.js
